<div [ngSwitch]="datePickerMode">
    <div *ngSwitchCase="DatePickerModeEnum.Date" class="date-picker">
        <dp-date-picker
                #dayPicker
                [(ngModel)]="selectedDate"
                [config]="datePickerConfig"
                [theme]="'dp-material'"
                (ngModelChange)="onDateSelected()">
        </dp-date-picker>
        <button class="btn btn-sm btn-primary button-with-icon" type="button" (click)="openDatePicker()">
            {{ selectedDate.format("DD-MM-YYYY") }}
            <svg class="icon" width="14" height="14">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="./sprites/symbol/icons.svg#calendar"
                     fill="currentColor"/>
            </svg>
        </button>
    </div>
    <div *ngSwitchCase="DatePickerModeEnum.Month" style="position: relative;">
        <input [dpDayPicker]="datePickerConfig"
               name="monthPicker"
               #monthPicker="dpDayPicker"
               mode="month"
               [theme]="'dp-material'"
               [(ngModel)]="selectedDate"
               (ngModelChange)="onDateSelected()"
        />
        <button class="btn btn-sm btn-primary" type="button" (click)="openMonthPicker()">
            {{ displayMonth }}
            <svg class="icon" width="14" height="14">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="./sprites/symbol/icons.svg#calendar"
                     fill="currentColor"/>
            </svg>
        </button>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/review-date-picker/review-date-picker.component.html